import React, { useEffect } from "react";
// import './notfoundstyle.css';

function UnderMaintenance(props) {
  let HeaderData = props.HeaderData;
  let stylePath = "assets/css/notfoundstyle.css";
  useEffect(() => {
    document.title = "Under Maintainence"
    // headerSet();
    var head = document.head;
    var link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = stylePath;

    head.appendChild(link);

    return () => {
      head.removeChild(link);
    };
  }, [stylePath]);
  return (
    <div id="404Page" className="services section-show">
      <div>
        <div className="noise"></div>
        <div className="overlay"></div>
        <div className="terminal">
          <h1>
            Under <span className="errorcode">Maintainence</span>
          </h1>
          <p className="output">
            This Website is Temporarily Unavailable due to Scheduled Maintainence
          </p>
          <p className="output">
            Please Visit Again
          </p>
          <p className="output">In the MeanTime you can contact me on any of the Platforms below</p>
          <div className="social-links">
            {HeaderData.socialLinks &&
              HeaderData.socialLinks.map((item, index) => {
                return (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    className="mx-2"
                    key={index}
                  >
                    <i className={`${item.className}`}></i>
                  </a>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnderMaintenance;
